var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center",attrs:{"id":_vm.vid}},[_c('div',{staticClass:"spinner-grow text-primary",attrs:{"role":"status"}}),_vm._v("\n        Loading Video...\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }